import React from 'react'

module.exports = [
  {
    title: 'Connect New Service',
    icon: 'fa-play',
    buttons: [
      {link: '/#/access/wizard', content: 'GO'}
    ]
  }, {
    title: 'Trouble Tickets',
    icon: 'fa-comments-o',
    buttons: [
      {link: '/#/ticket/create', content: 'GO'}
    ]
  }, {
    title: 'Available Accesses',
    icon: 'fa-home',
    buttons: [
      {link: '/#/export/access', content: <span> <i className='fa fa-cloud-download' /> EXPORT .CSV</span>}
    ]
  }, {
    title: 'Active Services',
    icon: 'fa-cog',
    buttons: [
      {link: '/#/soon', content: <span> <i className='fa fa-cloud-download' /> EXPORT .CSV</span>}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/config/dashboard.js